import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MultiSizeItem, MultiSizeState } from 'src/store/multisize/types';

export const multiSizeInitialState: MultiSizeState = {
  isOpen: false,
  isBatchSelectionOpen: false,
  pendingItems: [],
};

export const slice = createSlice({
  name: 'multisize',
  initialState: multiSizeInitialState,
  reducers: {
    openMultiSizeDrawerAction: (state) => {
      state.isOpen = true;
    },
    closeMultiSizeDrawerAction: (state) => {
      state.isOpen = false;
    },
    openBatchSelectionAction: (state) => {
      state.isBatchSelectionOpen = true;
    },
    closeBatchSelectionAction: (state) => {
      state.isBatchSelectionOpen = false;
    },
    setMultiSizePendingItemsAction: (state, action: PayloadAction<MultiSizeItem[]>) => {
      state.pendingItems = action.payload;
    },
    clearMultiSizePendingItemsAction: (state) => {
      state.pendingItems = [];
    },
  },
});

export const {
  openMultiSizeDrawerAction,
  closeMultiSizeDrawerAction,
  openBatchSelectionAction,
  closeBatchSelectionAction,
  setMultiSizePendingItemsAction,
  clearMultiSizePendingItemsAction,
} = slice.actions;

const multisize = slice.reducer;
export default multisize;
